import React from 'react'
import { connect } from 'react-redux';

import { DashboardModal } from '@uppy/react';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import GoogleDrive from '@uppy/google-drive';
import Dropbox from '@uppy/dropbox';
import Url from '@uppy/url';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';

import Attachments from '../Attachments/Attachments';
var moment = require('moment');

class UppyFileUpload extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}

        this.uppy2 = new Uppy({
            id: 'uppy2', autoProceed: false, debug: true, overridePatchMethod: true,
            restrictions: {
                maxFileSize: Number(this.props.envData.fileUploadLimit)
            },
            meta: {
                accountId: this.props.selectedAccount._id
            },
            locale: {
                strings: {
                    dropPaste: 'Drop files here or %{browse}',

                }
            }
        })
            .use(Tus, {
                headers: {
                    'Authorization': `Bearer ${this.props.accessToken}`
                },
                fingerprint: function (file, options) {
                    return new Date().getTime();
                },
                storeFingerprintForResuming: false,
                removeFingerprintOnSuccess: true,
                endpoint: `${process.env.REACT_APP_ASPEN_FILE_UPLOADER_URL}/files/`
            })
            .use(GoogleDrive, {
                id: 'addGoogleDrive',
                companionUrl: 'https://app.aspenify.com'
            })
            .use(Dropbox, {
                id: 'addDropbox',
                companionUrl: 'https://app.aspenify.com'
            })
            .use(Url, {
                id: 'addUrl',
                companionUrl: 'https://app.aspenify.com'
            }).on('complete', (result) => {
                let attachments = this.props.data && this.props.data.attachments ? this.props.data.attachments : [];

                for (let index = 0; index < result.successful.length; index++) {
                    const element = result.successful[index];
                    let document = {};
                    document.documentName = element.name;
                    let documentNameFromS3 = element.uploadURL.split('/').pop();
                    document.documentId = documentNameFromS3.split('.').slice(0, -1)[0];
                    document.uploadedBy = this.props.user && this.props.user._id;
                    document.uploadedAt = moment();
                    attachments.unshift(document);
                }

                this.props.action(attachments);
            })
    }

    handleModalClick = () => {
        this.props.handleUppyModalClick();
        this.uppy2.reset();
    }

    componentWillUnmount() {
        this.uppy2.close();
    }

    render() {
        return <div>
            <Attachments
                selectedData={this.props.data}
                attachments={this.props.data.attachments}
                user={this.props.user}
                resourceId={this.props.data._id}
                entityName={this.props.entityName}
                initiativeStatus={this.props.initiativeStatus}
                playbookStatus={this.props.playbookStatus}
                accountId={this.props.data.accountId}
                isPublic={this.props.isPublic}
                selectedOrganization={this.props.selectedOrganization}
                selectedPlaybook={this.props.selectedPlaybook}
                selectedInitiative={this.props.selectedInitiative}
                currentOrganization={this.props.currentOrganization}
                to={this.props.to}
                isAuthor = {this.props.isAuthor}
                status={this.props.status}
                isWorkspaceOwner={this.props.isWorkspaceOwner}
                isContributor={this.props.isContributor}

            />
            <DashboardModal
                uppy={this.uppy2}
                open={this.props.openDashboard}
                target={document.body}
                onRequestClose={this.handleModalClick}
                proudlyDisplayPoweredByUppy={false}
                showLinkToFileUploadResult={false}
                trigger='#modalButton'
            />
        </div>
    }
}

function mapStateToProps(state) {
    return {
        accessToken: state.login.accessToken,
        envData: state.app.envData,
        user: state.app.user,
        selectedAccount: state.app.selectedAccount
    };
}
const FileUploader = connect(mapStateToProps)(UppyFileUpload);

export default FileUploader;